module.exports = __webpack_public_path__ + "static/media/Big-Boost-Two-Lines-BG-Blue-800x480.90a87b8a.png";